<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      tableCardTitle="SCORE"
      :RightBtnOptions="{ text: 'New Event', isHavePermission: true }"
      @searchChange="params => _getTableData(params)"
      @pageChange="params => _getTableData(params)"
      @changeTitleActionBtn="
        $router.push({
          name: 'addScores',
          params: { customerId: $route.params.customerId },
        })
      "
    >
      <template v-slot:id="{ tableRow }">
        {{ tableRow.row.id.slice(-6) }}
      </template>
      <template v-slot:scoreCardStr="{ tableRow }">
        <a href="javascript:void (0)" @click="viewCardModel(tableRow.row)">
          {{ tableRow.row.scoreCardStr }}
        </a>
      </template>
      <template v-slot:score="{ tableRow }">
        {{
          tableRow.row.score == null
            ? tableRow.row.mmFinalCreditRating
            : tableRow.row.score
        }}
      </template>
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void(0)"
          class="icon-view1"
          style="color: #3a3f63; font-size: 18px"
          @click="viewCardResult(tableRow.row)"
        />
      </template>
    </table-view>
  </div>
</template>

<script>
import { getTableData } from './api'
import { getSelectList } from '@/api'

export default {
  data() {
    const searchModel = [
      {
        label: 'Scorecard Name',
        type: 'select',
        key: 'scoreCardId',
        selectList: [],
        width: 200,
        layout: {
          md: 24,
          lg: 10,
        },
      },
      {
        label: 'Status',
        type: 'select',
        key: 'status',
        selectList: [
          {
            id: 1,
            name: 'SUCCESS',
          },
          {
            id: 2,
            name: 'FAILURE',
          },
        ],
        layout: {
          md: 24,
          lg: 10,
        },
      },
    ]
    const tableModel = [
      {
        label: 'Event Id',
        slotName: 'id',
      },
      {
        width: 300,
        label: 'Scorecard Name',
        slotName: 'scoreCardStr',
      },
      {
        width: 120,
        label: 'Status',
        prop: 'statusStr',
      },
      {
        width: 80,
        label: 'Action',
        slotName: 'action',
      },
      {
        width: 170,
        label: 'Submission Date',
        prop: 'createTime',
      },
      {
        width: 150,
        label: 'Execution Date',
        prop: 'executionDate',
      },
      {
        width: 130,
        label: 'Financial Year',
        prop: 'financialYear',
      },
      {
        width: 100,
        label: 'Score',
        slotName: 'score',
      },
      {
        width: 140,
        label: 'Submitted By',
        prop: 'operator',
      },
      {
        width: 180,
        label: 'Theoretical Limit (USD)',
        prop: 'theoreticalLimit',
      },
      {
        minWidth: 130,
        label: 'Message',
        prop: 'message',
      },
      // {
      //   width: 80,
      //   label: 'action',
      //   slotName: 'action',
      // },
    ]
    return {
      tableModel,
      searchModel,
      tableData: [],
      pages: {},
      scoreNameList: [],
    }
  },
  mounted() {
    this.companyId = this.$route.params.customerId
    this.initTable()
    this._getSelectList()
  },
  methods: {
    viewCardModel({ scoreCardId }) {
      this.$router.push({
        name: 'score-model',
        params: {
          cardId: scoreCardId,
          customerId: this.$route.params.customerId,
        },
      })
    },
    viewCardResult({ id, scoreCardStr }) {
      if (scoreCardStr === 'Lenovo MM Non Public Scorecard') {
        this.$router.push({
          name: 'score-result',
          params: {
            id,
            customerId: this.$route.params.customerId,
            scoreCardStr,
          },
        })
      } else {
        this.$router.push({
          name: 'score-other',
          params: {
            id,
            customerId: this.$route.params.customerId,
            scoreCardStr,
          },
        })
      }
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    async _getSelectList() {
      try {
        this.searchModel[0].selectList = await getSelectList('ScoreCard')
      } catch (err) {
        console.error(err)
      }
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData({
          ...params,
          companyId: this.companyId,
        })
        this.tableData = data
        this.tableData.map(item => {
          var regPos = /^\d+(\.\d+)?$/
          var regNeg =
            /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/
          if (
            regPos.test(item.theoreticalLimit) ||
            regNeg.test(item.theoreticalLimit)
          ) {
            item.theoreticalLimit = this.$utils.formatAmount(
              item.theoreticalLimit,
            )
          } else {
            return item.theoreticalLimit
          }
        })
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
